var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C4.39819 0 1.875 2.52349 1.875 5.625C1.875 9.77479 7.06482 14.707 7.28578 14.9152C7.34619 14.9716 7.4231 15 7.5 15C7.5769 15 7.65381 14.9716 7.71425 14.9152C7.93518 14.707 13.125 9.77479 13.125 5.625C13.125 2.52349 10.6018 0 7.5 0ZM7.5 14.2502C6.51794 13.2697 2.49999 9.04784 2.49999 5.625C2.49999 2.86805 4.74305 0.62499 7.5 0.62499C10.257 0.62499 12.5 2.86805 12.5 5.625C12.5 9.04784 8.48206 13.2697 7.5 14.2502Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 2.5C5.77697 2.5 4.375 3.90197 4.375 5.62501C4.375 7.34805 5.777 8.75002 7.50001 8.75002C9.22302 8.75002 10.625 7.34805 10.625 5.62501C10.625 3.90197 9.22305 2.5 7.50001 2.5ZM7.50001 8.125C6.12121 8.125 5.00002 7.00349 5.00002 5.62501C5.00002 4.24653 6.12124 3.12502 7.50001 3.12502C8.87879 3.12502 10 4.24653 10 5.62501C10 7.00349 8.87882 8.125 7.50001 8.125Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.de7de08cb72cf6263363c5c7df3cb998.svg";
export { ForwardRef as ReactComponent };